import type { OnPageTransitionEndAsync } from "vike/types";
import { nprogress } from "@mantine/nprogress";

export const onPageTransitionEnd: OnPageTransitionEndAsync = async () => {
  nprogress.complete();
  console.log("%c...Page transition end ✨", "color: #7c3aed; font-weight: bold;");
};
